import { Box, Grid } from "@mui/material";
import Pagination from "../../../../components/DataGridPro/Pagination/Pagination";

interface OrderReviewLinesPaginationProps {
  page: number;
  pageSize: number;
  rowLength: number;
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  api: {
    setPage: (page: number) => void;
    setPaginationModel: (paginationModel: PaginationModel) => void;
  };
}

type PaginationModel = {
  pageSize: number;
  page: number;
};

const OrderLinesPagination = ({
  page,
  pageSize,
  rowLength,
  setPage,
  setPageSize,
  api,
}: OrderReviewLinesPaginationProps) => {
  const onChange = (updatedPage: number) => {
    setPage(updatedPage - 1);
    api.setPage(updatedPage - 1);
    api.setPaginationModel({
      pageSize,
      page: updatedPage - 1,
    });
  };

  const onPageSizeChange = (newPageSize: number) => {
    const newPage = Math.ceil(((page - 1) * pageSize + 1) / newPageSize);
    setPage(newPage - 1);
    api.setPage(newPage - 1);
    api.setPaginationModel({
      pageSize: newPageSize,
      page: newPage - 1,
    });
    setPageSize(newPageSize);
  };

  return (
    <Grid container display="flex">
      <Grid flex={2}>
        <Box display="flex">
          <Pagination
            rowsPerPage={pageSize}
            currentPage={page}
            totalCount={rowLength}
            onRowsPerPageChange={onPageSizeChange}
            onFirstPageClick={() => onChange(1)}
            onLastPageClick={() => onChange(Math.ceil(rowLength / pageSize))}
            onPreviousClick={() => onChange(page - 1)}
            onNextClick={() => onChange(page + 1)}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default OrderLinesPagination;
